<template>
  <nav class="site-sticky">
    <div class="site-nav site-nav--desktop ev-scroll-top-offset">
      <div class="container">
        <div class="site-nav--row main">
          <div class="site-nav--row__inner ev-flex ev-flex--justify-space-between ev-flex--align-center">
            <div class="site-nav-col left">
              <div class="nav-block nav-logo">
                <router-link to="/index"><img src="@/assets/images/logo-header.png" style="width:250px;"></router-link>
              </div>
            </div>
            <div class="site-nav-col right ev-align--flex-center-v">
              <div class="nav-block desktop-menu hidden-touch-devices">
                <ul id="desktop-menu" class="menu">
                  <li class="menu-item menu-item-type-custom menu-item-object-custom">
                    <router-link to="/">首页</router-link>
                  </li>

                  <li class="menu-item menu-item-type-custom menu-item-object-custom">
                    <router-link to="/company">关于我们</router-link>
                  </li>

                  <li class="menu-item menu-item-type-custom menu-item-object-custom">
                    <router-link to="/price">绿植租赁</router-link>
                  </li>

                  <li class="menu-item menu-item-type-custom menu-item-object-custom">
                    <router-link to="/wall">植物墙立体绿化</router-link>
                  </li>

                  <li class="menu-item menu-item-type-custom menu-item-object-custom">
                    <router-link to="/garden">花园景观</router-link>
                  </li>

                  <li class="menu-item menu-item-type-custom menu-item-object-custom">
                    <router-link to="/green">绿化养护</router-link>
                  </li>

                  <li class="menu-item menu-item-type-custom menu-item-object-custom">
                    <router-link to="/products">项目案例</router-link>
                  </li>

                  <li class="menu-item menu-item-type-post_type menu-item-object-page">
                    <router-link to="/contact">联系我们</router-link>
                  </li>
                </ul>
              </div>

              <div class="nav-block button" style="display:block;">
                <div class="elementor-element elementor-element-3c02d09 e-con-full sticky-btn e-flex e-con e-child"
                     data-element_type="container">
                  <div class="elementor-element elementor-element-c9d528f header-menu hover-link elementor-mobile-align-justify elementor-widget-mobile__width-initial elementor-widget elementor-widget-button"  data-element_type="widget" data-widget_type="button.default">
                    <div class="elementor-widget-container">
                      <div class="elementor-button-wrapper">


<span class="elementor-button-icon">
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_6_56)">
    <path
        d="M18.2465 15.8765C17.4624 15.1024 16.4836 15.1024 15.7045 15.8765C15.1102 16.4658 14.5158 17.0551 13.9315 17.6544C13.7717 17.8192 13.6369 17.8542 13.4421 17.7443C13.0575 17.5345 12.648 17.3647 12.2785 17.135C10.5555 16.0513 9.11215 14.6579 7.83364 13.0897C7.19938 12.3106 6.63504 11.4766 6.2405 10.5377C6.16059 10.3479 6.17558 10.2231 6.33039 10.0683C6.9247 9.49392 7.50402 8.90461 8.08834 8.3153C8.90239 7.49625 8.90239 6.53737 8.08335 5.71333C7.61889 5.24388 7.15443 4.78442 6.68997 4.31497C6.21053 3.83553 5.73609 3.35109 5.25165 2.87664C4.46757 2.11254 3.48871 2.11254 2.70962 2.88164C2.11032 3.47095 1.53599 4.07525 0.926699 4.65457C0.362357 5.18895 0.0776891 5.84318 0.017759 6.60729C-0.0771303 7.85084 0.227514 9.02447 0.657013 10.1681C1.53599 12.5354 2.87443 14.6379 4.49753 16.5657C6.68998 19.1726 9.30692 21.2352 12.3684 22.7235C13.7467 23.3927 15.1751 23.9071 16.7283 23.992C17.797 24.0519 18.7259 23.7823 19.4701 22.9482C19.9795 22.3789 20.5538 21.8595 21.0932 21.3151C21.8922 20.5061 21.8972 19.5272 21.1032 18.7281C20.1543 17.7743 19.2004 16.8254 18.2465 15.8765ZM17.2926 11.8961L19.1355 11.5815C18.8458 9.88846 18.0467 8.35525 16.8331 7.13667C15.5496 5.85317 13.9265 5.04412 12.1386 4.79441L11.8789 6.64724C13.2623 6.84202 14.5208 7.46629 15.5147 8.46013C16.4536 9.39903 17.0679 10.5876 17.2926 11.8961ZM20.1742 3.88547C18.0467 1.75795 15.3549 0.414516 12.3833 0L12.1236 1.85284C14.6906 2.21242 17.0179 3.37606 18.8558 5.20892C20.5987 6.95189 21.7424 9.15432 22.1569 11.5765L23.9998 11.2619C23.5153 8.45514 22.1919 5.90811 20.1742 3.88547Z"
        fill="#ffffff"></path>
  </g>
</svg>
</span>
                        <span class="elementor-button-text" style="color:#ffffff">免费报价：  <span
                            style="color:#ffffff">186 2183 9959</span></span> <br/>

                        <span class="elementor-button-icon">
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_6_56)">
    <path
        d="M18.2465 15.8765C17.4624 15.1024 16.4836 15.1024 15.7045 15.8765C15.1102 16.4658 14.5158 17.0551 13.9315 17.6544C13.7717 17.8192 13.6369 17.8542 13.4421 17.7443C13.0575 17.5345 12.648 17.3647 12.2785 17.135C10.5555 16.0513 9.11215 14.6579 7.83364 13.0897C7.19938 12.3106 6.63504 11.4766 6.2405 10.5377C6.16059 10.3479 6.17558 10.2231 6.33039 10.0683C6.9247 9.49392 7.50402 8.90461 8.08834 8.3153C8.90239 7.49625 8.90239 6.53737 8.08335 5.71333C7.61889 5.24388 7.15443 4.78442 6.68997 4.31497C6.21053 3.83553 5.73609 3.35109 5.25165 2.87664C4.46757 2.11254 3.48871 2.11254 2.70962 2.88164C2.11032 3.47095 1.53599 4.07525 0.926699 4.65457C0.362357 5.18895 0.0776891 5.84318 0.017759 6.60729C-0.0771303 7.85084 0.227514 9.02447 0.657013 10.1681C1.53599 12.5354 2.87443 14.6379 4.49753 16.5657C6.68998 19.1726 9.30692 21.2352 12.3684 22.7235C13.7467 23.3927 15.1751 23.9071 16.7283 23.992C17.797 24.0519 18.7259 23.7823 19.4701 22.9482C19.9795 22.3789 20.5538 21.8595 21.0932 21.3151C21.8922 20.5061 21.8972 19.5272 21.1032 18.7281C20.1543 17.7743 19.2004 16.8254 18.2465 15.8765ZM17.2926 11.8961L19.1355 11.5815C18.8458 9.88846 18.0467 8.35525 16.8331 7.13667C15.5496 5.85317 13.9265 5.04412 12.1386 4.79441L11.8789 6.64724C13.2623 6.84202 14.5208 7.46629 15.5147 8.46013C16.4536 9.39903 17.0679 10.5876 17.2926 11.8961ZM20.1742 3.88547C18.0467 1.75795 15.3549 0.414516 12.3833 0L12.1236 1.85284C14.6906 2.21242 17.0179 3.37606 18.8558 5.20892C20.5987 6.95189 21.7424 9.15432 22.1569 11.5765L23.9998 11.2619C23.5153 8.45514 22.1919 5.90811 20.1742 3.88547Z"
        fill="#ffffff"></path>
  </g>
</svg>
</span>
                        <span class="elementor-button-text" style="color:#ffffff">免费报价：  <span
                            style="color:#ffffff">135 2441 5736</span></span>



                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>

</template>
<script setup>
</script>